import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import defaultLayout from '@/layout/default';
import authLayout from '@/layout/auth';
import viewerLayout from '@/layout/viewer';
import LoginPage from '@/views/LoginPage';
import vuetify, { defaults } from '@/plugins/vuetify';
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: defaultLayout,
    redirect: () => {
      if (store.getters['auth/role'] === 'bn.master') {
        return { name: 'myProfile' };
      }
      return { name: 'myProfile' };
    },
    children: [
      {
        path: '/profiles',
        name: 'Profiles',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Identities'),
        meta: {
          auth: ['admin', 'bn.cashier'],
        },
        props: r => ({ selectedRole: r.query.role }),
      },
      {
        path: '/profiles/:id([0-9a-zA-Z]{24})',
        name: 'Profile',
        component: () =>
          import(/* webpackChunkName: "admin" */ '../views/Identities/identityDetails'),
        meta: {
          auth: ['admin', 'bn.cashier'],
        },
        props: r => ({ id: r.params.id, editMode: !!r.query.edit }),
      },
      {
        path: '/profiles/new',
        name: 'profileNew',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Identities/profileNew'),
        meta: {
          auth: ['admin', 'bn.cashier'],
        },
        props: r => ({ id: 'new', selectedRole: r.query.role }),
      },
      {
        path: '/myProfile',
        name: 'myProfile',
        component: () => import(/* webpackChunkName: "admin" */ '../views/MyProfile.vue'),
        meta: {
          auth: ['admin', 'bn.master', 'bn.cashier'],
        },
      },
      {
        path: '/SystemConfig',
        name: 'SystemConfig',
        component: () => import(/* webpackChunkName: "admin" */ '../views/SystemConfig/index'),
        meta: {
          auth: ['admin'],
        },
      },
      {
        path: '/settings',
        name: 'settings',
        redirect: '/options',
        meta: {
          auth: ['admin'],
        },
      },

      {
        path: '/changePassword/:id([0-9a-zA-Z]{24})',
        name: 'changePassword',
        component: () =>
          import(/* webpackChunkName: "changePassword" */ '../views/Identities/changePassword'),
        props: r => ({ id: r.params.id }),
      },
      {
        path: '/changeUserName/:id([0-9a-zA-Z]{24})',
        name: 'changeUserName',
        component: () =>
          import(/* webpackChunkName: "changePassword" */ '../views/Identities/changeUserName'),
        props: r => ({ id: r.params.id }),
      },
      {
        path: '/crm',
        name: 'crm',
        component: () => import(/* webpackChunkName: "admin" */ '../views/CRM/index'),
        meta: {
          auth: ['admin'],
        },
      },
      {
        path: '/yomt',
        name: 'yomt',
        component: () => import(/* webpackChunkName: "admin" */ '../views/YOMT/index'),
        meta: {
          auth: ['admin'],
        },
      },
      {
        path: '/lpms',
        name: 'lpms',
        component: () => import(/* webpackChunkName: "admin" */ '../views/LPMS/index'),
        meta: {
          auth: ['admin'],
        },
      },
      {
        path: '/lpms/for-sale-vehicle-list',
        name: 'for-sale-vehicle-list',
        component: () =>
          import(/* webpackChunkName: "admin" */ '../views/LPMS/forSaleVehicleList.vue'),
        meta: {
          auth: ['admin'],
          hideDrawer: true,
        },
      },
      {
        path: '/customer',
        name: 'customer',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Customer/index'),
        meta: {
          auth: ['admin'],
        },
      },
      {
        path: '/agent',
        name: 'agent',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Agent/index'),
        meta: {
          auth: ['admin'],
        },
      },
      {
        path: '/notifications',
        name: 'notifications',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Notifications'),
        meta: {
          auth: ['admin'],
        },
      },
      {
        path: '/opt-out',
        name: 'optOut',
        component: () => import(/* webpackChunkName: "admin" */ '../views/OptOut/index'),
        meta: {
          auth: ['admin'],
        },
      },
      {
        path: '/opt-log',
        name: 'optLog',
        component: () => import(/* webpackChunkName: "admin" */ '../views/OptLog/index'),
        meta: {
          auth: ['admin'],
        },
      },
      {
        path: '/whatsapp-messages',
        name: 'whatsappMessages',
        component: () =>
          import(/* webpackChunkName: "admin" */ '../views/WhatsappMessages/index'),
        meta: {
          auth: ['admin'],
        },
      },
      {
        path: '/developer',
        name: 'developer',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Developer/index.vue'),
        meta: {
          auth: ['admin'],
          requireDebugMode: true,
        },
      },

    ],
  },
  {
    path: '/viewer',
    name: 'viewerHome',
    component: viewerLayout,
    redirect: '/',
    children: [
      {
        path: '/file-viewer/:attachmentId([0-9a-zA-Z]{24})',
        name: 'FileViewerPage',
        component: () => import(/* webpackChunkName: "admin" */ '../views/FileViewerPage.vue'),
        meta: {
          auth: ['admin', 'bn.master', 'bn.cashier'],
        },
        props: true,
      },
    ],
  },
  {
    path: '/auth',
    name: 'authHome',
    component: authLayout,
    redirect: { name: 'login' },
    children: [
      {
        path: '/auth/login',
        name: 'login',
        component: LoginPage,
        props: r => ({ ret: r.query.ret }),
      },
      {
        path: '/auth/forgetpassword',
        name: 'forgetpassword',
        component: () => import('../views/LoginPage/forgetpw.vue'),
      },
      {
        path: '/auth/changeMyPassword',
        name: 'changeMyPassword',
        component: () => import('../views/ChangeMyPassword/index'),
      },
      // {
      //   path: '/forgotpassword',
      //   name: 'Password',
      //   component: () => import('../views/LoginPage/resetpw.vue'),
      //   props: r => ({ token: r.query.token }),
      // },
    ],
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;

router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.auth) {
    if (!store.getters['auth/isLoggedIn']) {
      return next({ name: 'login', query: { ret: to.fullPath } });
    }
    if (Array.isArray(to.meta.auth)) {
      if (!to.meta.auth.includes(store.getters['auth/role'])) {
        if (to.redirectedFrom === '/') {
          return next({ name: 'login', query: { ret: to.fullPath } });
        }
        return next('/');
      }
    }
  }
  next();
});
// router.afterEach((to, form) => {
//   vuetify.framework.theme.themes.light = { ...defaults };
//   switch (store.getters['auth/role']) {
//     case 'admin':
//       vuetify.framework.theme.themes.light.primary = '#561269';
//       break;
//     case 'bn.cashier':
//       vuetify.framework.theme.themes.light.primary = '#ff9505';
//       break;
//     case 'bn.master':
//       vuetify.framework.theme.themes.light.primary = '#179eeb';
//       break;
//     default:
//   }
//   if (typeof to.meta?.theme === 'object' && to.meta?.theme) {
//     Object.assign(vuetify.framework.theme.themes.light, to.meta.theme);
//   }
// });

export function canAccessRoute(to) {
  const r = router.resolve(to)?.route;
  if (!r) return false;
  const passAuthCheck =
    r && (!Array.isArray(r.meta?.auth) || r.meta.auth.includes(store.getters['auth/role']));
  const passDevCheck = r && (!r.meta?.isDevOnly || !!process.env.VUE_APP_SHOW_DEV_MENU_PATH);
  return passAuthCheck && passDevCheck;
}
